(function ( $ ) {
    $.fn.nibhvLocationSelector = function(val, params) {
        $(this).each(function() {
            const elm = $(this);

            elm.attr('data-search-type', 'nibhv_location');

            elm.specialSelector({
                val: val,
                option: function(row) {
                    return '<option value="'+row.id+'">' + row.name + '</option>';
                },
                onOpen: function(id) {
                    view_evaluation(id);
                }
            });
        });
        return this;
    };

}( jQuery ));
